import { Modal } from '@appkit4/react-components/modal';
import { Button } from '@appkit4/react-components/button';
import { Dispatch, SetStateAction, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from 'Constants';
import useLocale from 'locale/useLocale';
import { useAuth } from 'react-oidc-context';

export type NavigateToHistoryModalProps = {
    visible: boolean;
    setVisible: Dispatch<SetStateAction<boolean>>;
};

const NavigateToHistoryModal = ({
    visible,
    setVisible,
}: NavigateToHistoryModalProps) => {
    const navigate = useNavigate();
    const { l } = useLocale();
    const { isAuthenticated } = useAuth();

    const handleConfirmNavigate = () => {
        navigate(AppRoutes.History);
        setVisible(false);
    };

    useEffect(() => {
        if (!isAuthenticated) {
            setVisible(false);
        }
    }, [isAuthenticated, setVisible]);

    return (
        <Modal
            visible={visible}
            maskBodyPadding={false}
            title={'Navigate away?'}
            ariaLabel={'Are you sure you want to navigate away?'}
            onCancel={() => setVisible(false)}
            footerStyle={{
                paddingTop: '16px',
                marginTop: '-8px',
                minHeight: '64px',
            }}
            icons={''}
            closable={false}
            header={
                <span className="ap-notification-icon Appkit4-icon height icon-error-fill" />
            }
            footer={
                <>
                    <Button onClick={() => setVisible(false)} kind="secondary">
                        {l('_cancel')}
                    </Button>
                    <Button onClick={handleConfirmNavigate}>
                        {l('_navigateToHistory')}
                    </Button>
                </>
            }
        >
            <p>{l('_areYouSureNavigateAway')}</p>
        </Modal>
    );
};

export default NavigateToHistoryModal;
